import React from 'react'
import './dictatedBy.scss'

const DictatedBy = props => {
  const { dictatedByInfo, isSecondStyle, tituloDictadoPor } = props

  return (
    <div className={isSecondStyle ? 'dictated-by--secondary' : 'dictated-by'}>
      <div className='dictated-by__title'>
        <h3>{tituloDictadoPor ? tituloDictadoPor : 'Dictado Por:'}</h3>
      </div>
      <div className='dictated-by__cardContainer'>
        {dictatedByInfo &&
          dictatedByInfo.map((conferencista, index) => (
            <div className='dictated-by__cardContainer-card' key={index}>
              <div className='dictated-by__cardContainer-card-img'>
                <img
                  src={conferencista.imagenConferencistaLeccion.file.url}
                  alt=''
                />
              </div>
            </div>
          ))}
      </div>
    </div>
  )
}

export default DictatedBy
